import { media, variables } from '@domain-group/fe-brary';
import { css } from '@emotion/core';
var global = variables.global;
export var searchLocation = {
  name: "b2vj5l",
  styles: "display:flex;width:100%;gap:15px;"
};
export var autocompleteContainer = isActive => /*#__PURE__*/css("width:100%;", media('>=tablet'), "{height:40px;", isActive && /*#__PURE__*/css("z-index:", global.layerPopout + 1, ";"), "}");
export var autocomplete = /*#__PURE__*/css(media('>=tablet'), "{box-shadow:0 1px 4px 0 rgb(0 0 0 / 15%);}");